// Code generated by tools/scripts/generate-agent-gui-provider-catalog.mjs. DO NOT EDIT.

export const generatedProviderIdentityCatalog = [
  {
    providerId: "codex",
    displayName: "Codex",
    iconKey: "codex",
    localeKey: "agentHost.agentGui.conversationFilterCodex",
    aliases: [],
    modelPlanProtocol: "openai",
    statusKind: "codex_cli",
    target: {
      id: "local:codex",
      launchRefType: "local_cli",
      enabled: true,
      sortOrder: 10
    },
    desktop: {
      managed: true,
      managedOrder: 2,
      statusProbePriority: 1,
      usageProbeKind: "codex",
      visibilityGate: "",
      runtimeProbeFallback: "",
      installBootstrap: false,
      refreshOnAccountChange: false,
      unavailableDockOrderOffset: 0,
      developerLogs: true,
      defaultProviderEligible: true,
      defaultProviderPriority: 2
    }
  },
  {
    providerId: "claude-code",
    displayName: "Claude Code",
    iconKey: "claude-code",
    localeKey: "agentHost.agentGui.conversationFilterClaudeCode",
    aliases: ["claude", "claude code"],
    modelPlanProtocol: "anthropic",
    statusKind: "claude_cli",
    target: {
      id: "local:claude-code",
      launchRefType: "local_cli",
      enabled: true,
      sortOrder: 20
    },
    desktop: {
      managed: true,
      managedOrder: 1,
      statusProbePriority: 2,
      usageProbeKind: "claude_code",
      visibilityGate: "",
      runtimeProbeFallback: "",
      installBootstrap: false,
      refreshOnAccountChange: false,
      unavailableDockOrderOffset: 0,
      developerLogs: true,
      defaultProviderEligible: true,
      defaultProviderPriority: 3
    }
  },
  {
    providerId: "cursor",
    displayName: "Cursor",
    iconKey: "cursor",
    localeKey: "agentHost.agentGui.conversationFilterCursor",
    aliases: ["cursor-agent", "cursor agent", "cursor-cli"],
    modelPlanProtocol: "",
    statusKind: "generic_cli",
    target: {
      id: "local:cursor",
      launchRefType: "local_cli",
      enabled: true,
      sortOrder: 30
    },
    desktop: {
      managed: true,
      managedOrder: 3,
      statusProbePriority: 3,
      usageProbeKind: "",
      visibilityGate: "",
      runtimeProbeFallback: "direct",
      installBootstrap: false,
      refreshOnAccountChange: false,
      unavailableDockOrderOffset: 0,
      developerLogs: true,
      defaultProviderEligible: true,
      defaultProviderPriority: 4
    }
  },
  {
    providerId: "tutti-agent",
    displayName: "Tutti Agent",
    iconKey: "tutti",
    localeKey: "agentHost.agentGui.conversationFilterTutti",
    aliases: ["tutti agent"],
    modelPlanProtocol: "openai",
    statusKind: "generic_cli",
    target: {
      id: "local:tutti-agent",
      launchRefType: "local_cli",
      enabled: true,
      sortOrder: 5
    },
    desktop: {
      managed: true,
      managedOrder: 4,
      statusProbePriority: 4,
      usageProbeKind: "",
      visibilityGate: "tutti_agent",
      runtimeProbeFallback: "",
      installBootstrap: true,
      refreshOnAccountChange: true,
      unavailableDockOrderOffset: 0,
      developerLogs: true,
      defaultProviderEligible: true,
      defaultProviderPriority: 1
    }
  },
  {
    providerId: "opencode",
    displayName: "OpenCode",
    iconKey: "opencode",
    localeKey: "agentHost.agentGui.conversationFilterOpenCode",
    aliases: ["open-code", "open code", "opencode-ai", "opencode_ai"],
    modelPlanProtocol: "openai",
    statusKind: "opencode_cli",
    target: {
      id: "local:opencode",
      launchRefType: "local_cli",
      enabled: true,
      sortOrder: 50
    },
    desktop: {
      managed: true,
      managedOrder: 5,
      statusProbePriority: 5,
      usageProbeKind: "",
      visibilityGate: "",
      runtimeProbeFallback: "",
      installBootstrap: false,
      refreshOnAccountChange: false,
      unavailableDockOrderOffset: 0,
      developerLogs: false,
      defaultProviderEligible: true,
      defaultProviderPriority: 5
    }
  },
  {
    providerId: "nexight",
    displayName: "Nexight",
    iconKey: "tutti",
    localeKey: "agentHost.agentGui.conversationFilterNexight",
    aliases: ["tutti"],
    modelPlanProtocol: "",
    statusKind: "generic_cli",
    target: {
      id: "local:nexight",
      launchRefType: "local_cli",
      enabled: false,
      sortOrder: 60
    },
    desktop: {
      managed: false,
      managedOrder: 0,
      statusProbePriority: 0,
      usageProbeKind: "",
      visibilityGate: "",
      runtimeProbeFallback: "",
      installBootstrap: false,
      refreshOnAccountChange: false,
      unavailableDockOrderOffset: 0,
      developerLogs: false,
      defaultProviderEligible: false,
      defaultProviderPriority: 0
    }
  },
  {
    providerId: "openclaw",
    displayName: "OpenClaw",
    iconKey: "openclaw",
    localeKey: "agentHost.agentGui.conversationFilterOpenClaw",
    aliases: ["open-claw"],
    modelPlanProtocol: "",
    statusKind: "generic_cli",
    target: {
      id: "local:openclaw",
      launchRefType: "local_cli",
      enabled: false,
      sortOrder: 80
    },
    desktop: {
      managed: true,
      managedOrder: 7,
      statusProbePriority: 7,
      usageProbeKind: "",
      visibilityGate: "",
      runtimeProbeFallback: "",
      installBootstrap: false,
      refreshOnAccountChange: false,
      unavailableDockOrderOffset: 200,
      developerLogs: false,
      defaultProviderEligible: false,
      defaultProviderPriority: 0
    }
  }
] as const;
